const N = "#142344";
const P = "#D81B60";
const Y = "#FFC83D";
const C = "#FFF7E8";
const s = { stroke: N, strokeWidth: 3, strokeLinejoin: "round", strokeLinecap: "round" };

const ART = {
  cheers: (
    <>
      <g transform="rotate(-14 28 44)"><path d="M18 22 h20 l-3 34 h-14 z" fill={C} {...s} /><path d="M20 36 h16 l-1.6 18 h-12.8 z" fill={Y} /><path d="M18 22 h20 l-3 34 h-14 z" fill="none" {...s} /></g>
      <g transform="rotate(14 52 44)"><path d="M42 22 h20 l-3 34 h-14 z" fill={C} {...s} /><path d="M44 34 h16 l-1.8 20 h-12.4 z" fill={P} /><path d="M42 22 h20 l-3 34 h-14 z" fill="none" {...s} /></g>
      <path d="M40 6 v8 M30 10 l4 6 M50 10 l-4 6" {...s} fill="none" />
    </>
  ),
  kurta: (
    <>
      <path d="M28 10 h24 l16 12 -7 10 -7 -4 v42 h-28 v-42 l-7 4 -7 -10 z" fill={P} {...s} />
      <path d="M36 10 l4 8 4 -8 M40 18 v22" fill="none" {...s} />
      <circle cx="40" cy="26" r="2" fill={Y} /><circle cx="40" cy="34" r="2" fill={Y} />
      <path d="M26 62 h28" stroke={Y} strokeWidth="4" />
    </>
  ),
  phone: (
    <>
      <rect x="24" y="8" width="32" height="62" rx="7" fill={C} {...s} />
      <rect x="29" y="16" width="22" height="40" rx="2" fill={Y} stroke={N} strokeWidth="2" />
      <circle cx="40" cy="63" r="2.5" fill={N} />
      <path d="M12 14 L68 66" stroke={P} strokeWidth="6" strokeLinecap="round" />
    </>
  ),
  dice: (
    <>
      <rect x="10" y="26" width="30" height="30" rx="6" fill={C} transform="rotate(-12 25 41)" {...s} />
      <rect x="40" y="18" width="30" height="30" rx="6" fill={Y} transform="rotate(10 55 33)" {...s} />
      {[[19, 35], [25, 41], [31, 47]].map(([x, y]) => <circle key={x} cx={x} cy={y} r="2.6" fill={N} />)}
      {[[49, 27], [61, 27], [49, 39], [61, 39]].map(([x, y]) => <circle key={`${x}${y}`} cx={x} cy={y} r="2.6" fill={P} />)}
    </>
  ),
  coins: (
    <>
      {[58, 50, 42].map((y) => <ellipse key={y} cx="34" cy={y} rx="20" ry="7" fill={Y} {...s} />)}
      <circle cx="54" cy="30" r="16" fill={Y} {...s} />
      <text x="54" y="37" textAnchor="middle" fontSize="20" fontWeight="800" fill={N} fontFamily="DM Sans, sans-serif">₹</text>
    </>
  ),
};

export default function RuleArt({ icon, className = "" }) {
  return (
    <svg viewBox="0 0 80 80" className={className} aria-hidden="true" focusable="false">
      {ART[icon] || ART.cheers}
    </svg>
  );
}
